import { SVGProps } from 'react';

export const ArticleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='22'
    height='22'
    viewBox='0 0 22 22'
    fill='none'
    {...props}>
    <path
      d='M8.55238 13.1485H15.4489M8.55238 10.2826H11.311M8.55238 7.41671H11.311M6.35338 7.41667H3.59458C3.28561 7.41667 3.03516 7.67686 3.03516 7.99785V15.5968C3.03516 16.583 3.77782 17.429 4.72698 17.447C5.69396 17.4654 6.48341 16.6566 6.48341 15.6562V5.13196C6.48341 4.81098 6.73387 4.55078 7.04284 4.55078H17.6481C17.9571 4.55078 18.2076 4.81098 18.2076 5.13196V15.6562C18.2076 16.6454 17.4356 17.4473 16.4834 17.4473H4.75925M13.5596 7.41667H15.2693C15.3685 7.41667 15.4489 7.50023 15.4489 7.60332V10.0959C15.4489 10.199 15.3685 10.2826 15.2693 10.2826H13.5596C13.4604 10.2826 13.38 10.199 13.38 10.0959V7.60332C13.38 7.50023 13.4604 7.41667 13.5596 7.41667Z'
      strokeWidth='1.4'
      strokeLinecap='round'
    />
  </svg>
);
